import {
    ChangeDetectorRef,
    Component,
    ContentChild,
    ElementRef,
    EventEmitter,
    forwardRef,
    Input,
    Output,
    TemplateRef
} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIDeprecatedTextControlComponent} from "../deprecated-text-control/deprecated-text-control.component";
import {FUIResponsiveService} from "../../page/responsive.service";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FUIDeprecatedAutocompleteControlComponent),
    multi: true
};

@Component({
    providers: [CUSTOM_VALUE_ACCESSOR],
    selector: "fui-deprecated-autocomplete-control",
    styleUrls: ["./deprecated-autocomplete-control.component.scss"],
    templateUrl: "./deprecated-autocomplete-control.component.html",
    standalone: false
})
export class FUIDeprecatedAutocompleteControlComponent extends FUIDeprecatedTextControlComponent {
    @ContentChild("autocompletecontrolresults", {read: TemplateRef}) public autocompleteControlResults: TemplateRef<HTMLTemplateElement>;
    @Output() filtered: EventEmitter<any> = new EventEmitter();
    public hasToggle: boolean;
    @Input() public increment: number;
    @Input() public limit: number;
    public position: number;
    @Input() public results: any[];
    @Input() public showMore: string;

    constructor(changeDetectorRef: ChangeDetectorRef,
                protected elementRef: ElementRef,
                protected responsiveService: FUIResponsiveService) {
        super(changeDetectorRef);
    }

    override get value(): any {
        return super.value;
    }

    override set value(value: any) {
        super.value = value;
        this.filtered.emit(value);
    }

    isToggled(): boolean {
        if (this.value) {
            if (this.hasToggle) {
                return true;
            }
        }
        return false;
    }

    leave(): void {
        this.hasToggle = false;
    }

    override onFocus(): void {
        this.focussed = true;
        this.hasToggle = true;
        this.focussed$.emit(this.focussed);
    }
}
